import React, { ReactElement, useContext } from 'react'
import { LanguageProvider } from '../react-intl/LanguageContext';
import { Header as KTRHeader } from 'ktr-materialui-react';
import { Translations } from '../react-intl/Translations';
import { Language } from '../react-intl/types/language';
import { useIntl } from 'react-intl';


export default function Header(): ReactElement {
    const { language, changeLanguage } = useContext(LanguageProvider);
    const { formatMessage: f } = useIntl();

    const currentLanguage = Translations.filter(lang => lang.langcode === language)[0];

    return (
        <KTRHeader
        showLanguageChanger={true}
        languages={Translations}
        languageHelperText={f({id:'app.select.lang'})}
        getLanguageLabel={(lang: Language) => { return lang.language }}
        getLanguageValue={(lang: Language) => { return lang.langcode }}
        getLanguageSelected={(lang: Language) => { return lang.langcode === language }}
        getCurrentLanguage={() => { return currentLanguage.language }}
        onLangChange={(lang: Language) => changeLanguage(lang.langcode)}
        hyperlinkLogo="https://otools.ktr.com/clampexassistant"
      />
    )
}
